module.exports = __webpack_public_path__ + "static/img/b32.7d4953d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/b32.jpg
// module id = 1sJV
// module chunks = 1